import Polipop from 'polipop';
import { Plus, Pen, ArchiveBig, Restore } from 'assets/icons';

export const appStatuses = {
  all_statuses: 'all_statuses',
  ready_to_promote: 'ready_to_promote',
  promoting: 'promoting',
  archived: 'archived',
  all_but_archived: 'all_but_archived',
  monetising: 'monetising',
  awaiting: 'awaiting',
  error: 'error',
};

export const publisherAppStatuses = {
  all_statuses: 'all_statuses',
  monetising: 'monetising',
  awaiting: 'awaiting',
  archived: 'archived',
  all_but_archived: 'all_but_archived',
};

export const advertiserFilterItems = [
  {
    name: 'All Statuses',
    id: 'all_statuses',
  },
  {
    name: 'All But Archived',
    id: 'all_but_archived',
  },
  {
    name: 'Promoting',
    id: 'promoting',
  },
  {
    name: 'Ready to Promote',
    id: 'ready_to_promote',
  },
  {
    name: 'Archived',
    id: 'archived',
  },
  // {
  //   name: 'Error',
  //   id: 'error',
  // },
];

export const publisherFilterItems = [
  {
    name: 'All Statuses',
    id: 'all_statuses',
  },
  {
    name: 'All But Archived',
    id: 'all_but_archived',
  },
  {
    name: 'Monetising',
    id: 'monetising',
  },
  {
    name: 'Awaiting for SDK integration',
    id: 'awaiting',
  },
  {
    name: 'Archived',
    id: 'archived',
  },
  // {
  //   name: 'Error',
  //   id: 'error',
  // },
];

export const appTypeFilterItems = [
  { name: 'All Application Types', id: 'all_types' },
  { name: 'Apps', id: 'apps' },
  { name: 'Websites', id: 'websites' },
];

export const menuActions = {
  app_settings: 'app_settings',
  promote_this_app: 'promote_this_app',
  archive: 'archive',
  restore: 'restore',
};

export const menuPlacementsActions = {
  start_now: { statusName: 'Start Now', value: '3', id: 'start_now' },
  pause: { statusName: 'Pause', value: '0', id: 'pause' },
};

export const menuItems = [
  {
    name: 'App Settings',
    id: 'app_settings',
    icon: <Pen />,
    type: 'link',
  },
  {
    name: 'Promote this App',
    id: 'promote_this_app',
    icon: <Plus />,
    type: 'link',
  },
  {
    name: 'Restore',
    id: 'restore',
    icon: <Restore />,
    type: 'div',
  },
  {
    name: 'Archive',
    id: 'archive',
    icon: <ArchiveBig />,
    type: 'div',
  },
];

export const publisherLocalizationPages = [
  {
    name: 'General Settings',
    id: 'general_settings',
    link: '',
    url_id: 'manageApps/appSettings/generalSettings',
    disabled: false,
    display: true,
  },
  {
    name: 'Placements',
    id: 'placements',
    link: '',
    url_id: 'manageApps/appSettings/placements',
    disabled: false,
    display: false,
  },
  {
    name: 'Exclude Settings',
    id: 'exclude_settings',
    url_id: 'manageApps/appSettings/excludeSettings',
    link: '',
    disabled: false,
    display: true,
  },
  {
    name: 'Minimum Serving',
    id: 'minimum_serving',
    link: '',
    url_id: 'manageApps/appSettings/minimumServing',
    disabled: false,
    display: false,
  },
  {
    name: 'App Install Postback',
    id: 'app_install_postback',
    link: '',
    url_id: 'manageApps/appSettings/appInstallPostback',
    disabled: false,
    display: false,
  },
];

export const advancedLocalizationPages = [
  {
    name: 'Exclude Settings',
    id: 'exclude_settings',
    url_id: 'manageApps/excludeSettings',
    link: '',
    disabled: false,
  },
  {
    name: 'Minimum Serving',
    id: 'minimum_serving',
    link: '',
    url_id: 'manageApps/minimumServing',
    disabled: false,
  },
  {
    name: 'App Install Postback',
    id: 'app_install_postback',
    link: '',
    url_id: 'manageApps/appInstallPostback',
    disabled: false,
  },
];

export const minServingFields = {
  network: {
    field: 'networkCampaigns',
    countriesErrorName: 'networkCountries',
  },
  directBuy: {
    field: 'directBuyCampaigns',
    countriesErrorName: 'directBuyCountries',
  },
};

export const polipop = new Polipop('mypolipop', {
  layout: 'popups',
  insert: 'after',
  pool: 1,
  life: 2000,
  progressbar: true,
  closer: false,
  theme: 'minimal',
});

export const userTypes = {
  advertiser: 'advertiser',
  publisher: 'publisher',
  admin: 'admin',
};

export const newAppPages = {
  google: 'google',
  samsung: 'samsung',
  xiaomi: 'xiaomi',
};
